import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "#6E6E6E",
      "clip-path": "url(#i-1961276282__a)"
    }, [
      _createElementVNode("path", { d: "M10.037 6.66h14.318a11.615 11.615 0 0 1-1.508 2.331H12.382l2.345 2.33h5.775a39.451 39.451 0 0 1-3.3 2.46l1.685 1.674c4.655-3.208 8.85-6.885 8.85-13.467h-2.345c0 .785-.07 1.57-.235 2.33H7.68l2.345 2.331.012.012ZM21.975 25.328H7.657c.412-.832.907-1.617 1.508-2.33H19.63l-2.345-2.331H11.51a39.429 39.429 0 0 1 3.3-2.46l-1.685-1.674C8.47 19.74 4.275 23.419 4.275 30H6.62c0-.785.07-1.57.235-2.33h17.477l-2.346-2.33-.011-.012ZM3.284 2.082 2.001 3.357l26.715 26.548L30 28.63 3.284 2.082Z" })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "i-1961276282__a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M2 2h28v28H2z"
        })
      ])
    ], -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "icon_ogm"}) } }